import React, { useState, useEffect } from "react";
import {
  Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, IconButton, InputBase, Pagination, Menu, MenuItem,CircularProgress
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ExportDropdown from "../../../components/ExportDropdown";
import CustomText, { textStyles } from "../../../components/CustomText";
import StatusDropdown from "../../../components/StatusDropdown";
import RequestDetailsDrawer from "../Requests/DetailsDrawer.js";
import { useTranslation } from "react-i18next";
import filtericon from "../../../assets/filtericon.svg";
import { showUnderDevelopment } from "../../../components/Alert";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../Utlis/Encryption.js";
import { BASE_URL } from "../../../components/BaseUrl.js";
import TruncatedCell from "../../../components/TruncatedCell.js";
import FilterDrawer from "../Requests/filterDrawer.js";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import emptypayment from "../../../assets/emptypayment.png";
import back from "../../../assets/back.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import mapicon from "../../../assets/Dashboard/mapicon.svg";
import { convertUTCToLocalDateTime } from "../../../components/dateTimeUtils.js";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useTheme } from "../../../contexts/ThemeContext";

import { pdf } from "@react-pdf/renderer";
const HeaderStyles = {
  color: "#44546F",
  fontSize: "15px",
  fontWeight: 600,
  fontFamily: "Poppins, sans-serif",
  whiteSpace: "nowrap",
};

const DataStyles = {
  color: "#172B4D",
  fontSize: "13px",
  fontWeight: 400,
  fontFamily: "Poppins, sans-serif",
  whiteSpace: "nowrap",
};

const DashboardRequest = () => {
  const { t } = useTranslation();

  const [requests, setRequests] = useState([]);
  const [paginationInfo, setPaginationInfo] = useState({});
  const [loading, setLoading] = useState(false);
const [refreshList, setRefreshList] = useState(false);
const location = useLocation();
  const navigate = useNavigate();
  const fromDashboard = location.state?.fromDashboard;
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
  const [search, setSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuRow, setMenuRow] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
const [initialLoading, setInitialLoading] = useState(true);   // full screen loader
const [tableLoading, setTableLoading] = useState(false); 
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
const { company } = useSelector((state) => state.auth);
const companyId = company?.id;
const { primaryColor } = useTheme();
console.log(companyId)
const [filterOpen, setFilterOpen] = useState(false);
const [filters, setFilters] = useState({ status: "", startDate: "", endDate: "" });

const fetchRequests = async (page = 1, limit = 5, isInitial = false, appliedFilters = filters) => {
  try {
    if (isInitial) setInitialLoading(true);
    else setTableLoading(true);

    const { status, startDate, endDate } = appliedFilters;
    let query = `search=${search}&page=${page}&limit=${limit}`;
    if (status) query += `&status=${status}`;
    if (startDate) query += `&start_date=${startDate}`;
    if (endDate) query += `&end_date=${endDate}`;
//     if (appliedFilters.startDate) filterQuery += `&from=${appliedFilters.startDate}`;
// if (appliedFilters.endDate) filterQuery += `&to=${appliedFilters.endDate}`;

    const res = await fetch(
      `${BASE_URL}/requests/v1/companies/${companyId}/requests?${query}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${decryptedToken}`,
        },
      }
    );

    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    const data = await res.json();
    setRequests(data.data || []);
    setPaginationInfo(data.pagination || {});
  } catch (err) {
    console.error("Failed to fetch requests", err);
  } finally {
    setInitialLoading(false);
    setTableLoading(false);
  }
};


const [didMount, setDidMount] = useState(false);

useEffect(() => {
  fetchRequests(currentPage, 5, true);   // first load with big loader
  setDidMount(true);
}, []);

useEffect(() => {
  if (didMount) {
    fetchRequests(currentPage, 5);   // subsequent loads with small loader
  }
}, [currentPage, refreshList, search, didMount]);

  const formatRequestTypeLabel = (type) => {
    if (!type) return "-";
    const keyByType = {
      LEAVE: "requestManagement.requestTypes.LEAVE",
      SCHEDULE_CHANGE: "requestManagement.requestTypes.SCHEDULE_CHANGE",
      GENERIC_HR: "requestManagement.requestTypes.GENERIC_HR",
    };
    const i18nKey = keyByType[type];
    if (i18nKey) return t(i18nKey);
    return String(type)
      .split("_")
      .map((w) => w.charAt(0) + w.slice(1).toLowerCase())
      .join(" ");
  };

  // Filter by search
  const filteredData = requests.filter((row) => {
    const q = search.toLowerCase();
    const typeLabel = formatRequestTypeLabel(row.type).toLowerCase();
    return (
      row.type?.toLowerCase().includes(q) ||
      typeLabel.includes(q) ||
      row.leave_reason_text?.toLowerCase().includes(q) ||
      row.status?.toLowerCase().includes(q)
    );
  });
const formatDateTime = (dateString) => {
  const formatted = convertUTCToLocalDateTime(dateString, {
    locale: "en-GB",
    formatOptions: {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    },
  });
  return formatted === "—" ? "-" : formatted;
};


const fetchAllRequests = async () => {
  try {
    let allRows = [];
    let page = 1;
    let totalPages = 1;

    do {
      let query = `search=${search}&page=${page}&limit=50000`; // use 100 or higher if API allows
      if (filters.status) query += `&status=${filters.status}`;
      if (filters.startDate) query += `&start_date=${filters.startDate}`;
      if (filters.endDate) query += `&end_date=${filters.endDate}`;

      const url = `${BASE_URL}/requests/v1/companies/${companyId}/requests?${query}`;
      console.log("📡 Fetching export page:", page, url);

      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${decryptedToken}` },
      });
      const json = await res.json();

      if (json.error) break;

      const mapped = (json.data || []).map((row) => ({
        id: row.id,
        type: formatRequestTypeLabel(row.type),
        reason: row.leave_reason_text || "-",
        date: formatDateTime(row.created_at),
        comments: row.admin_comment || "-",
        status: row.status || "-",
      }));

      allRows = [...allRows, ...mapped];
      totalPages = json.pagination?.pages || 1;
      page++;
    } while (page <= totalPages);

    return allRows;
  } catch (err) {
    console.error("❌ Fetch all requests failed:", err);
    return [];
  }
};

const handleIcon = () => {
    navigate("/request-management", { state: { fromDashboard: true } });
}
  return (
<>
          {fromDashboard && (
  <Box
    sx={{
      border: '1px solid #E4E6EF',
      borderRadius: 2,
      px: 2,
      backgroundColor: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      minHeight: 55,
      mb: 2,
      ml:1, mr:1
    }}
  >
    <Box
      sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
      onClick={() => navigate(-1)}
    >
      <img src={back} style={{ width: 30, height: 30 }} />
      <CustomText
        sx={{
          ...textStyles.h1,
          fontWeight: 500,
          fontSize: '14px',
          color: '#626F86',
          textAlign: 'center'
        }}
      >
        {t('companyAdmin')} 
      </CustomText>
    </Box>
  </Box>
)}
    <Box sx={{ backgroundColor: "white", borderRadius: 2, border: "2px solid #091E4224", py: 2, px: 2, mt: 1, ml:1, mr:1 }}>
      
      {/* Header */}
      <Box
        sx={{
          pb: 2,
          borderBottom: "2px solid #091E4224",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
  <CustomText
    sx={{ ...textStyles.h1, fontWeight: 600, fontSize: "18px", color: "#003149" }}
  >
    {t("requestManagement.heading")}
  </CustomText>
  {tableLoading && !initialLoading && (
    <CircularProgress size={20} />
  )}</Box>
        {/* Search */}
        <Box
          sx={{
            px: 1,
            py: 0.2,
            borderRadius: 1,
            height: 34,
            border: "2px solid #091E4224",
            display: "flex",
            alignItems: "center",
            minWidth: 250,
            maxWidth: 300,
          }}
        >
          <InputBase
            // placeholder={t("requestManagement.searchPlaceholder")}
            placeholder={t("searchRequestByReason")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{
              fontSize: 14,
              fontFamily: "Poppins, sans-serif",
              color: "#939393",
              width: "100%",
            }}
          />
          <SearchIcon sx={{ fontSize: 20, color: "#888", ml: 1 }} />
        </Box>

      
          {/* <IconButton>
            <img
              src={mapicon}
              onClick={handleIcon}
              alt="map"
              style={{ width: 33, height: 33 }}
            />
          </IconButton> */}
          <IconButton
  onClick={handleIcon}
  sx={{
    width: 36,
    height: 36,
    borderRadius: "6px",
    backgroundColor: primaryColor,
    color: "#fff",
    "&:hover": {
      backgroundColor: primaryColor,
      opacity: 0.9,
    },
  }}
>
  <ArrowForwardIosIcon sx={{ fontSize: 20 }} />
</IconButton>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.id")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.type")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.reason")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.date")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.comments")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.status")}</TableCell>
              <TableCell sx={HeaderStyles}>{t("requestManagement.tableHeaders.action")}</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {initialLoading ? (
              <TableRow>
                <TableCell colSpan={7} align="center"><CircularProgress size={40} /></TableCell>
              </TableRow>
            ) : filteredData.length > 0 ? (
              filteredData.map((row, i) => (
                <TableRow key={i}>
                  <TableCell sx={DataStyles}>{row.id}</TableCell>
                  <TableCell sx={DataStyles}>{formatRequestTypeLabel(row.type)}</TableCell>
                  <TableCell sx={DataStyles}>
                    {/* {row.leave_reason_text || "-"}
                     */}
                               <TruncatedCell text={row.leave_reason_text || "-"}/>
                     
                  </TableCell>
                  <TableCell sx={DataStyles}>
                    {/* {new Date(row.leave_start_date).toLocaleDateString()} –{" "}
                    {new Date(row.created_at).toLocaleTimeString()} */}
{formatDateTime(row.created_at)}

                  </TableCell>
                  <TableCell sx={DataStyles}>
                    {row.admin_comment || "-"}
                  </TableCell>
                  <TableCell sx={DataStyles}>
                    <Box sx={{ pointerEvents: "none" }}>
                      <StatusDropdown currentStatus={row.status} />
                    </Box>
                  </TableCell>
                  <TableCell>
                    <IconButton size="small"   onClick={(e) => {
    setAnchorEl(e.currentTarget);
    setMenuRow(row);   // ✅ store clicked row
  }}>
                      <MoreVertIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center">            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                py: 5,
              }}
            >
              <img
                src={emptypayment}
                alt="No Data"
                style={{ width: 200, marginBottom: 16 }}
              />
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#003149",
                }}
              >
                {t("empty.no_user")}
              </CustomText>
            </Box></TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Menu */}
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => { setAnchorEl(null); setMenuRow(null); }}>
  <MenuItem
  onClick={() => {
    if (menuRow) {
      setSelectedRow(menuRow);   // save the full row
      setDrawerOpen(true);
    }
    setAnchorEl(null);
  }}
  sx={{ fontSize: 13, fontFamily: "Poppins, sans-serif" }}
>
  {t("unvalidatedPunches.tableActions.view")}
</MenuItem>
      </Menu>

      {/* Pagination */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <Pagination
          count={paginationInfo.pages || 1}
          page={currentPage}
          onChange={(_, val) => setCurrentPage(val)}
          shape="rounded"
          color="primary"
          size="small"
                sx={{
                "& .MuiPaginationItem-root": {
                  fontFamily: "Poppins, sans-serif",
                  fontSize: 13,
                  fontWeight: 500,
                },
                "& .Mui-selected": {
                  backgroundColor: "#E9F3FF",
                  color: "#006EC2",
                },
              }}
        />
      </Box>

<RequestDetailsDrawer
  open={drawerOpen}
  onClose={() => setDrawerOpen(false)}
  row={selectedRow}
    onStatusChanged={() => setRefreshList((prev) => !prev)}   // 👈 added
/>  
<FilterDrawer
  open={filterOpen}
  onClose={() => setFilterOpen(false)}
  filters={filters}
  setFilters={setFilters}
  onApplyFilters={(applied) => {
    setFilters(applied);
    fetchRequests(1, 5, false, applied); // refresh with new filters
  }}
/>

  </Box>
  </>
  );
};

export default DashboardRequest;









